export default __webpack_public_path__ + "static/rotate_gif-5daa922a6c103e12d726486eb9d5194e.gif";